import logo from "../../../assets/images/logo/logo.png";

import { HeaderLogoWrapperStyled } from "../styles/headerLogo.styled";

const HeaderLogo = props => {

  return (
    <HeaderLogoWrapperStyled {...props}>
      <a href="/">
        <img src={logo} alt="Logo" />{" "}
      </a>
    </HeaderLogoWrapperStyled>
  );
};

export default HeaderLogo;
